export default __webpack_public_path__ + "9df85e7c20de1c7a79dc766b7c444247.png";